import { IActionFn, IPageData } from '@/store/types';
import { $http } from '@/axios';
import { IModuleState } from './types';
import { getStorage } from '@/utils/storage';

// 查询当前企业已授权的品牌列表
export const queryAuthedBrandPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuthedBrandPage', { ...state.authedBrandPage, loading: true });
    const orgId = JSON.parse(getStorage('orgInfo') || '{}').id;
    const res: IPageData = await $http.post('/v1/system/org/authbrands', { ...payload, orgId});
    const { list: data, pageNum, pageSize, total } = res;
    commit('setAuthedBrandPage', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setAuthedBrandPage', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询指定品牌已授权的企业列表
export const queryAuthedOrgPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuthedOrgPage', { ...state.authedBrandPage, loading: true });
    const res: IPageData = await $http.post('/v1/baseinfo/brand/authorg', payload);
    const { list: data, pageNum, pageSize, total } = res;
    commit('setAuthedOrgPage', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setAuthedOrgPage', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};
